import React from 'react';
import useCanUserViewFeature from '../../../hooks/useCanUserViewFeature';
import { PermissionGuardAlertBox } from './PermissionGuardAlertBox';
export const PermissionGuardBanner = (props) => {
    const { canView, isLoading } = useCanUserViewFeature(props.permissions, props.resource);
    if (canView || isLoading)
        return null;
    return React.createElement(PermissionGuardAlertBox, { isFullPage: props.isFullPage });
};
